import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import { hiddenBoxStyle } from './CepFormConfigurationGroup.style';
import ContentCard from 'components/ContentCard';
import { FormLayoutContainer } from 'components/FormLayout';
import useCepFormConfigurationGroup from 'groups/CepFormConfigurationGroup/CepFormConfigurationGroup.hook';
import { CepFormConfigurationGroupPropsType } from 'groups/CepFormConfigurationGroup/CepFormConfigurationGroup.types';
import Box from 'yoda-ui/components/Box';
import DateRangePicker from 'yoda-ui/components/Form/DateRangePicker';
import SelectYoda from 'yoda-ui/components/Form/SelectYoda';
import TextYoda from 'yoda-ui/components/Form/TextYoda';
import { fromUnitsToRem, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

const CepFormConfigurationGroup: FC<CepFormConfigurationGroupPropsType> = ({ isTemplate }) => {
  const {
    cepFormConfigurationGroup,
    handleCustomerInitiativeChange,
    handleChangeTA,
    handleChangeProduct,
    handleDateChange,
  } = useCepFormConfigurationGroup(isTemplate);

  const flags = useFlags();

  return (
    <>
      <ContentCard sx={ { marginBottom: fromUnitsToRem(YodaSpacing.large) } }>
        <FormLayoutContainer justifyContent={ YodaJustifyContent.spaceBetween } flexDirection="column" >
          <Box>
            <TextYoda { ...cepFormConfigurationGroup.title } />
          </Box>
          <Box paddingTop={ YodaSpacing.large }>
            <SelectYoda
              { ...cepFormConfigurationGroup.customerInitiative }
              onChange={ handleCustomerInitiativeChange }
            />
          </Box>
          <Box>
            <TextYoda { ...cepFormConfigurationGroup.ciDateStart } display={ false }/>
          </Box>
          <Box>
            <TextYoda { ...cepFormConfigurationGroup.ciDateEnd } display={ false } />
          </Box>
          <Box paddingTop={ YodaSpacing.large }>
            <DateRangePicker { ...cepFormConfigurationGroup.date } onChange={ handleDateChange } />
          </Box>
        </FormLayoutContainer>
      </ContentCard>
      <ContentCard>
        <FormLayoutContainer justifyContent={ YodaJustifyContent.spaceBetween } flexDirection="column" >
          <Box>
            <SelectYoda { ...cepFormConfigurationGroup.therapeuticArea } onChange={ handleChangeTA } />
          </Box>
          <Box paddingTop={ YodaSpacing.large }>
            <SelectYoda
              { ...cepFormConfigurationGroup.product }
              onChange={ handleChangeProduct }
              disabled={ cepFormConfigurationGroup.product.disabled }
            />
          </Box>
          <Box paddingTop={ YodaSpacing.large }>
            <SelectYoda { ...cepFormConfigurationGroup.biogenFunction } />
          </Box>
          <Box sx={
            flags.mayaAkma264RemovalOfUnusedFields
              ? hiddenBoxStyle
              : { paddingTop: fromUnitsToRem(YodaSpacing.large) }
          }>
            <TextYoda { ...cepFormConfigurationGroup.kpi } />
          </Box>
        </FormLayoutContainer>
      </ContentCard>
    </>
  );
};

export default CepFormConfigurationGroup;
